import { deleteData, getData, postData } from '~/utils/service';
import { GetReferencesEvent, OnDeleteRequest, OnGetReferencePDF, OnSendRequest } from './events';
import { Context, Scope } from './types';
import { transformFormValuesToPeerRefRequest } from './utils';

const ROUTE_NAME = 'peerReferencesRequest';
const PROVIDER_PEER_REF_ROUTE_NAME = 'providerPeerReference';
const RESEND_ROUTE_NAME = 'peerReferencesRequestResend';
const BASE_URL = 'peer_reference_request';
const REFERENCE_URL = `${BASE_URL}/peer_reference`;

export const PEER_REFERENCE_REQ_ROUTES = {
  post: `${BASE_URL}/request`,
  get: `${BASE_URL}/{id}`,
};

// [MCV-1814] Re-send a still-pending request email (same link, owner only).
export const PEER_REFERENCE_REQ_RESEND_ROUTES = {
  post: `${BASE_URL}/{id}/resend`,
};

export const PROVIDER_PEER_REFERENCE_ROUTES = {
  delete: `${REFERENCE_URL}/{id}`,
  get: `${REFERENCE_URL}/{id}`,
};

interface PeerReferenceRequestInput<T> {
  input: {
    context: Context;
    event: T;
  };
}

export const REFERENCES_API_CALLS = {
  get: async ({ input }: { input: Scope }): Promise<GetReferencesEvent> =>
    await getData(ROUTE_NAME, {
      pathParams: { id: input.context.providerId.toString() },
    }),
  create: async ({ input }: PeerReferenceRequestInput<OnSendRequest>) => {
    const event = input.event;
    await postData(ROUTE_NAME, {
      data: event.values,
      transformRequest: transformFormValuesToPeerRefRequest,
    });
  },
};

export const REFERENCE_API_CALLS = {
  resend: async ({ input }: { input: { id: number } }) => {
    await postData(RESEND_ROUTE_NAME, { pathParams: { id: input.id.toString() } });
  },
  delete: async ({ input }: PeerReferenceRequestInput<OnDeleteRequest>) => {
    await deleteData(PROVIDER_PEER_REF_ROUTE_NAME, {
      pathParams: { id: input.event.payload.id.toString() },
    });
  },
  get: async ({ input }: PeerReferenceRequestInput<OnGetReferencePDF>) => {
    return await getData(PROVIDER_PEER_REF_ROUTE_NAME, {
      responseType: 'arraybuffer',
      pathParams: { id: input.event.payload.id.toString() },
    });
  },
};
